<template>
  <div>
    <div v-if="$slots.lastUpdated" class="content-center text-xs xl:text-sm">
      <slot name="lastUpdated" />
    </div>
    <access-control :roles="canDeleteRoles">
      <button
        v-if="isEdit"
        class="flex h-10 w-10 min-w-10 items-center justify-center rounded-sm border hover:text-red-500"
        @click="$emit('delete')"
      >
        <icon-base :icon="IconTrashOutline" class="cursor-pointer" />
      </button>
    </access-control>
    <access-control lendflow clients :exclude="excludedSaveRoles">
      <button
        v-if="showDraft"
        data-cy="save-changes"
        type="submit"
        class="min-w-[140px] rounded-md bg-blue-100 px-6 font-semibold text-primary shadow-md hover:bg-blue-200"
        :form="form"
        :disabled="isSubmitting"
        @click.prevent="$emit('save-draft')"
      >
        {{ $t("ORCHESTRATION.SAVE_AS_DRAFT") }}
      </button>
      <primary-button
        data-cy="publish-changes"
        :form="form"
        :disabled="isSubmitting"
        @click.prevent="$emit('publish')"
      >
        <slot name="publishText">
          {{
            isPublished ? $t("COMMON.PUBLISH_CHANGES", 2) : $t("COMMON.PUBLISH")
          }}
        </slot>
      </primary-button>
    </access-control>
  </div>
</template>

<script setup lang="ts">
import { ADMIN, CLIENT_ADMIN, SUPER_ADMIN, USER } from "@/helpers/constants";
import IconTrashOutline from "@/components/icons/IconTrashCanOutline.vue";

defineEmits<{
  "save-draft": [];
  publish: [];
  delete: [];
}>();

withDefaults(
  defineProps<{
    isEdit: boolean;
    isSubmitting: boolean;
    isPublished: boolean;
    showDraft: boolean;
    excludedSaveRoles?: string | string[];
    canDeleteRoles?: string | string[];
    form: string;
  }>(),
  {
    excludedSaveRoles: () => [USER],
    canDeleteRoles: () => [CLIENT_ADMIN, SUPER_ADMIN, ADMIN],
  }
);
</script>
